import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 背景色 */
enum BackgroundColor {
  black = 'BLACK',
  pink = 'PINK',
  blue = 'BLUE',
  orange = 'ORANGE',
  green = 'GREEN',
  purple = 'PURPLE',
}

const nameConfig = {
  black: new Map([[Locale.ja, '■']]),
  blue: new Map([[Locale.ja, '■']]),
  green: new Map([[Locale.ja, '■']]),
  orange: new Map([[Locale.ja, '■']]),
  pink: new Map([[Locale.ja, '■']]),
  purple: new Map([[Locale.ja, '■']]),
};

const toEnum = rawValueToEnum(BackgroundColor, BackgroundColor.black);
const toDisplay = enumToName(BackgroundColor, nameConfig);
const toDisplayWithPrefix = enumToName(BackgroundColor, nameConfig, { prefix: true });

export const backgroundColor = {
  enum: BackgroundColor,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { BackgroundColor };
